module.exports = __webpack_public_path__ + "4c9944d7103327e7aa33ee64e73b49cc.MP3";